
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as helpDYyJE18qQIFgXGO6AW0HB_459b0ZSmGCECqeKjnR3p_45boMeta } from "/workspace/frontend/pages/help.vue?macro=true";
import { default as homej52Hj5e_45HLhietK2M93ES_4Q8K6I5FGz7dhEPTUccNcMeta } from "/workspace/frontend/pages/home.vue?macro=true";
import { default as indexyjKI6NmT2h9fsIyM5GIGGgp7bpo8aNBg3ohAsFQmvpUMeta } from "/workspace/frontend/pages/index.vue?macro=true";
import { default as loginqvjLicPS9WDBaYLufcVyLFsCkH4ICENaEg3wHQYwZ5UMeta } from "/workspace/frontend/pages/login.vue?macro=true";
import { default as logout7ryG96Vn56YiD4_PEBLgp1JpY8IP1Z5HENlJo1cYUQwMeta } from "/workspace/frontend/pages/logout.vue?macro=true";
import { default as profileOLEO0BMQYlYn2iyygKfMgFMabBwymd25luNmCqWqvKAMeta } from "/workspace/frontend/pages/profile.vue?macro=true";
import { default as indexiggbeRs97SMQlpEIG2_PT8HlScQFosNknwwScj5ukvIMeta } from "/workspace/frontend/pages/jobs/index.vue?macro=true";
import { default as indexoN5YbRGmzIQNExjICr3VqC4TELgnwxnJoUa7qBqz2agMeta } from "/workspace/frontend/pages/audit/index.vue?macro=true";
import { default as accept_45termsQzRF9f3Kwr1aEtgo9rv0NhNjGZe1_45wUhasjxifPhuYUMeta } from "/workspace/frontend/pages/accept-terms.vue?macro=true";
import { default as help_45previewrq5S41uKVBxHSshI_O9pptaorEEq7h5xJfI3Z0pCahMMeta } from "/workspace/frontend/pages/help-preview.vue?macro=true";
import { default as indexNfL8gFjPyEC5Bi0owpjHvOzkjFxfT2p8iLZL3ILsImcMeta } from "/workspace/frontend/pages/signup/index.vue?macro=true";
import { default as verify_45emailwBgunJmYNzfIPlrBpMPeb5OLJgP_45XNcGkFVUeW_45RCpQMeta } from "/workspace/frontend/pages/verify-email.vue?macro=true";
import { default as callbacksfXq7W_tQFGjAjyoRoU9j9jJEOTI4aujXIURa3aFG6gMeta } from "/workspace/frontend/pages/oidc/callback.vue?macro=true";
import { default as indexB1WrFTgf4oHFwE7U_45yJZKboccUKf6UPZJin2ZpFUITAMeta } from "/workspace/frontend/pages/process/index.vue?macro=true";
import { default as cancelIf6awYXQieUfc_45HhcRyD_u4txmFd_mT5TKwGPJm0eMsMeta } from "/workspace/frontend/pages/signup/cancel.vue?macro=true";
import { default as forgotPasswordejvfAiLTZlTqkzrmJJBc_45j2vVNr_45tvtxpGqz4oYyQz8Meta } from "/workspace/frontend/pages/forgotPassword.vue?macro=true";
import { default as _91id_93srjw4HkhQ2cQL_45K40dSRaaBmjnEUViXzW3hWCEPbKx8Meta } from "/workspace/frontend/pages/jobs/edit/[id].vue?macro=true";
import { default as indexmMDUYH3lkt3a9j2YHWBYMHNj6_45dv9yXcctKLNkQq9PkMeta } from "/workspace/frontend/pages/jobs/kit/index.vue?macro=true";
import { default as reset_45passwordem4eJ_R0TYi4ArumM8rEMDHwdH1qfA_45K1NRIDiO9qXsMeta } from "/workspace/frontend/pages/reset-password.vue?macro=true";
import { default as success5dgRV7XxGIplqfhYP0RHsAwBa8W4cz_45JRn65Pn6JyOwMeta } from "/workspace/frontend/pages/signup/success.vue?macro=true";
import { default as indexgyaEJGLgbi35l9_0MCGlWHv5ZZXjasMIT2tSFqRYlIIMeta } from "/workspace/frontend/pages/training/index.vue?macro=true";
import { default as getting_45startedR66AAx2t8HEZvqJSz9ENBBBdacPtC61Mnhf_450jhyUVMMeta } from "/workspace/frontend/pages/getting-started.vue?macro=true";
import { default as indexpDS6Ha0SLXCHBwQBSlY0xb9DClP3VZnJ4gzWitxaktoMeta } from "/workspace/frontend/pages/jobs/edit/index.vue?macro=true";
import { default as matrix5o0bIkdjQ78jsk6x1JDJplhgZN0DfAmpvFFOQYnXY4MMeta } from "/workspace/frontend/pages/jobs/kit/matrix.vue?macro=true";
import { default as signup_45completeqdezU8yoMhlGy_oe98j7E4PS4U29UNRbFM_zFZZKFzgMeta } from "/workspace/frontend/pages/signup-complete.vue?macro=true";
import { default as access_45restrictedijOUpK6YJXXOvm_45iVndOsxPk_OPIJ1EhFzDDxnPK8tQMeta } from "/workspace/frontend/pages/access-restricted.vue?macro=true";
import { default as _91id_93LYL9u3n9lgwFx8iFqKl1SHX_4EBPE6YSgIW4XUW2NgYMeta } from "/workspace/frontend/pages/audit/report/[id].vue?macro=true";
import { default as indexvujyKaa7fbKIq43iTi1gXcF2QFaJQux08_45SserFIObsMeta } from "/workspace/frontend/pages/audit/report/index.vue?macro=true";
import { default as indexMpjXwOBqu85HgP1RC38LfjCiyeZ_uFQNd9Dr0vVKnHIMeta } from "/workspace/frontend/pages/jobs/kit/[id]/index.vue?macro=true";
import { default as packet3xXeEHAewFHPToi6a3zaa8LxvZ5frkBqKWQFf5_458l1QMeta } from "/workspace/frontend/pages/jobs/kit/[id]/packet.vue?macro=true";
import { default as organizationSettings77cuxe0wpk1Sv0WE0rfwsUrl4av5DW1DBgZfgaEZ_ccMeta } from "/workspace/frontend/pages/organizationSettings.vue?macro=true";
import { default as _91feature_93rXxQl17Q3HaVMg_45KA9yzs1qsc3D1oPD4x3DXQt3oSV8Meta } from "/workspace/frontend/pages/coming-soon/[feature].vue?macro=true";
import { default as summaryoUMMAU_1Iv2n5lnnV80DnoCa5sZdoH_45ztKrg_45nj4PN0Meta } from "/workspace/frontend/pages/jobs/kit/[id]/summary.vue?macro=true";
import { default as questionskVaAEljktWcpC043F1v_45llozGMNB88clrlWZbpQ0yzAMeta } from "/workspace/frontend/pages/jobs/kit/[id]/questions.vue?macro=true";
import { default as descriptionmlS_fi3_FAwMAO51NMmY2xWM_45G_45L1Df8MabdVDM0dtgMeta } from "/workspace/frontend/pages/jobs/kit/[id]/description.vue?macro=true";
import { default as offshore_45advisorwLfwkOUv7K8XOgoyPqvOqeuA9t5p60jrpM8dtDX_45cSgMeta } from "/workspace/frontend/pages/jobs/kit/offshore-advisor.vue?macro=true";
import { default as index_45Cmik_9m8xMtSwiuc_457p6cdrgnbTfX5sOqzuQbGOe7YMeta } from "/workspace/frontend/pages/training/mock-interview/index.vue?macro=true";
import { default as interview_45stagesezKLRRsbj6IAFoKijzq9R8CgIml41e5PPnx9r0j3fswMeta } from "/workspace/frontend/pages/jobs/kit/[id]/interview-stages.vue?macro=true";
import { default as question_45checkerLRQEkjmMBchEGHgE72W3teEQaM6zxBrvkuq1p0yAiMcMeta } from "/workspace/frontend/pages/jobs/kit/[id]/question-checker.vue?macro=true";
import { default as sessionzkirCMUHw8FiMRCmrUJGLOwCcwjAMl67h9NKCUvJicMMeta } from "/workspace/frontend/pages/training/mock-interview/session.vue?macro=true";
import { default as interview_45architectBGKFxE4FuIkVf4JwHJON8ZJIJCfj_zuejZkqlV2QrdYMeta } from "/workspace/frontend/pages/jobs/kit/[id]/interview-architect.vue?macro=true";
import { default as indexhMTJUzrXGjj7tRfKqydRm0FxG9821VhyswDuS7xpsmMMeta } from "/workspace/frontend/pages/training/difficult-conversations/index.vue?macro=true";
import { default as sessionjiU7Zi9B10B_45Joh0p_R8d9WlgE_45mbmJx_zG5a4SzhKoMeta } from "/workspace/frontend/pages/training/difficult-conversations/session.vue?macro=true";
import { default as component_45stubO8ly0NNAJaNDenF6KyqeDlwrYN7IDg23toNnJg8gUMYMeta } from "/workspace/frontend/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubO8ly0NNAJaNDenF6KyqeDlwrYN7IDg23toNnJg8gUMY } from "/workspace/frontend/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "help",
    path: "/help",
    component: () => import("/workspace/frontend/pages/help.vue")
  },
  {
    name: "home",
    path: "/home",
    component: () => import("/workspace/frontend/pages/home.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexyjKI6NmT2h9fsIyM5GIGGgp7bpo8aNBg3ohAsFQmvpUMeta || {},
    component: () => import("/workspace/frontend/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/workspace/frontend/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/workspace/frontend/pages/logout.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/workspace/frontend/pages/profile.vue")
  },
  {
    name: "jobs",
    path: "/jobs",
    component: () => import("/workspace/frontend/pages/jobs/index.vue")
  },
  {
    name: "audit",
    path: "/audit",
    component: () => import("/workspace/frontend/pages/audit/index.vue")
  },
  {
    name: "accept-terms",
    path: "/accept-terms",
    component: () => import("/workspace/frontend/pages/accept-terms.vue")
  },
  {
    name: "help-preview",
    path: "/help-preview",
    meta: help_45previewrq5S41uKVBxHSshI_O9pptaorEEq7h5xJfI3Z0pCahMMeta || {},
    component: () => import("/workspace/frontend/pages/help-preview.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/workspace/frontend/pages/signup/index.vue")
  },
  {
    name: "verify-email",
    path: "/verify-email",
    meta: verify_45emailwBgunJmYNzfIPlrBpMPeb5OLJgP_45XNcGkFVUeW_45RCpQMeta || {},
    component: () => import("/workspace/frontend/pages/verify-email.vue")
  },
  {
    name: "oidc-callback",
    path: "/oidc/callback",
    component: () => import("/workspace/frontend/pages/oidc/callback.vue")
  },
  {
    name: "process",
    path: "/process",
    component: () => import("/workspace/frontend/pages/process/index.vue")
  },
  {
    name: "signup-cancel",
    path: "/signup/cancel",
    meta: cancelIf6awYXQieUfc_45HhcRyD_u4txmFd_mT5TKwGPJm0eMsMeta || {},
    component: () => import("/workspace/frontend/pages/signup/cancel.vue")
  },
  {
    name: "forgotPassword",
    path: "/forgotPassword",
    component: () => import("/workspace/frontend/pages/forgotPassword.vue")
  },
  {
    name: "jobs-edit-id",
    path: "/jobs/edit/:id()",
    meta: _91id_93srjw4HkhQ2cQL_45K40dSRaaBmjnEUViXzW3hWCEPbKx8Meta || {},
    component: () => import("/workspace/frontend/pages/jobs/edit/[id].vue")
  },
  {
    name: "jobs-kit",
    path: "/jobs/kit",
    component: () => import("/workspace/frontend/pages/jobs/kit/index.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () => import("/workspace/frontend/pages/reset-password.vue")
  },
  {
    name: "signup-success",
    path: "/signup/success",
    meta: success5dgRV7XxGIplqfhYP0RHsAwBa8W4cz_45JRn65Pn6JyOwMeta || {},
    component: () => import("/workspace/frontend/pages/signup/success.vue")
  },
  {
    name: "training",
    path: "/training",
    meta: indexgyaEJGLgbi35l9_0MCGlWHv5ZZXjasMIT2tSFqRYlIIMeta || {},
    component: () => import("/workspace/frontend/pages/training/index.vue")
  },
  {
    name: "getting-started",
    path: "/getting-started",
    meta: getting_45startedR66AAx2t8HEZvqJSz9ENBBBdacPtC61Mnhf_450jhyUVMMeta || {},
    component: () => import("/workspace/frontend/pages/getting-started.vue")
  },
  {
    name: "jobs-edit",
    path: "/jobs/edit",
    component: () => import("/workspace/frontend/pages/jobs/edit/index.vue")
  },
  {
    name: "jobs-kit-matrix",
    path: "/jobs/kit/matrix",
    component: () => import("/workspace/frontend/pages/jobs/kit/matrix.vue")
  },
  {
    name: "signup-complete",
    path: "/signup-complete",
    meta: signup_45completeqdezU8yoMhlGy_oe98j7E4PS4U29UNRbFM_zFZZKFzgMeta || {},
    component: () => import("/workspace/frontend/pages/signup-complete.vue")
  },
  {
    name: "access-restricted",
    path: "/access-restricted",
    component: () => import("/workspace/frontend/pages/access-restricted.vue")
  },
  {
    name: "audit-report-id",
    path: "/audit/report/:id()",
    component: () => import("/workspace/frontend/pages/audit/report/[id].vue")
  },
  {
    name: "audit-report",
    path: "/audit/report",
    component: () => import("/workspace/frontend/pages/audit/report/index.vue")
  },
  {
    name: "jobs-kit-id",
    path: "/jobs/kit/:id()",
    component: () => import("/workspace/frontend/pages/jobs/kit/[id]/index.vue")
  },
  {
    name: "jobs-kit-id-packet",
    path: "/jobs/kit/:id()/packet",
    component: () => import("/workspace/frontend/pages/jobs/kit/[id]/packet.vue")
  },
  {
    name: "organizationSettings",
    path: "/organizationSettings",
    component: () => import("/workspace/frontend/pages/organizationSettings.vue")
  },
  {
    name: "coming-soon-feature",
    path: "/coming-soon/:feature()",
    component: () => import("/workspace/frontend/pages/coming-soon/[feature].vue")
  },
  {
    name: "jobs-kit-id-summary",
    path: "/jobs/kit/:id()/summary",
    component: () => import("/workspace/frontend/pages/jobs/kit/[id]/summary.vue")
  },
  {
    name: "jobs-kit-id-questions",
    path: "/jobs/kit/:id()/questions",
    component: () => import("/workspace/frontend/pages/jobs/kit/[id]/questions.vue")
  },
  {
    name: "jobs-kit-id-description",
    path: "/jobs/kit/:id()/description",
    component: () => import("/workspace/frontend/pages/jobs/kit/[id]/description.vue")
  },
  {
    name: "jobs-kit-offshore-advisor",
    path: "/jobs/kit/offshore-advisor",
    meta: {"middleware":"global-talent-advisor"},
    component: () => import("/workspace/frontend/pages/jobs/kit/offshore-advisor.vue")
  },
  {
    name: "training-mock-interview",
    path: "/training/mock-interview",
    meta: index_45Cmik_9m8xMtSwiuc_457p6cdrgnbTfX5sOqzuQbGOe7YMeta || {},
    component: () => import("/workspace/frontend/pages/training/mock-interview/index.vue")
  },
  {
    name: "jobs-kit-id-interview-stages",
    path: "/jobs/kit/:id()/interview-stages",
    component: () => import("/workspace/frontend/pages/jobs/kit/[id]/interview-stages.vue")
  },
  {
    name: "jobs-kit-id-question-checker",
    path: "/jobs/kit/:id()/question-checker",
    component: () => import("/workspace/frontend/pages/jobs/kit/[id]/question-checker.vue")
  },
  {
    name: "training-mock-interview-session",
    path: "/training/mock-interview/session",
    meta: sessionzkirCMUHw8FiMRCmrUJGLOwCcwjAMl67h9NKCUvJicMMeta || {},
    component: () => import("/workspace/frontend/pages/training/mock-interview/session.vue")
  },
  {
    name: "jobs-kit-id-interview-architect",
    path: "/jobs/kit/:id()/interview-architect",
    component: () => import("/workspace/frontend/pages/jobs/kit/[id]/interview-architect.vue")
  },
  {
    name: "training-difficult-conversations",
    path: "/training/difficult-conversations",
    meta: indexhMTJUzrXGjj7tRfKqydRm0FxG9821VhyswDuS7xpsmMMeta || {},
    component: () => import("/workspace/frontend/pages/training/difficult-conversations/index.vue")
  },
  {
    name: "training-difficult-conversations-session",
    path: "/training/difficult-conversations/session",
    meta: sessionjiU7Zi9B10B_45Joh0p_R8d9WlgE_45mbmJx_zG5a4SzhKoMeta || {},
    component: () => import("/workspace/frontend/pages/training/difficult-conversations/session.vue")
  },
  {
    name: component_45stubO8ly0NNAJaNDenF6KyqeDlwrYN7IDg23toNnJg8gUMYMeta?.name,
    path: "/privacy-policy.html",
    component: component_45stubO8ly0NNAJaNDenF6KyqeDlwrYN7IDg23toNnJg8gUMY
  },
  {
    name: component_45stubO8ly0NNAJaNDenF6KyqeDlwrYN7IDg23toNnJg8gUMYMeta?.name,
    path: "/cookie-policy.html",
    component: component_45stubO8ly0NNAJaNDenF6KyqeDlwrYN7IDg23toNnJg8gUMY
  }
]